export class AlertZone {
  color = "";
  startZone = 0;
  endZone = 0;
}

export class PatientSummary {
  firstName = "";
  lastName = "";
  participantId = 0;
  show = false;
  phoneNumber?: string;
  patientId?: string;
  mrn?: string;
  phq9?: number;
  phq9Change?: number;
  gad7?: number;
  gad7Change?: number;
  sows?: number;
  sowsChange?: number;
  sleep?: number;
  duration?: number;
  msi?: number;
  sleepChange?: number;
  labStatus?: boolean;
  observationDate?: string;
  labStatusChange?: number;
  appointmentColor?: string;
  appointmentChange?: number;
  watch?: boolean;
  watchStatus?: number;
  appVersion?: string;
  imeiId?: string;
  select = false;
  groupNames?: string;
  stressScore?: number;
}

export class Utox {
  date?: string;
  failed?: boolean;
  color?: string;
  css?: string;
  udsItems?: Uds;
}

export class Uds {
  patientId = "";
  firstName = "";
  lastName = "";
  dob = "";
  testName = "";
  results = "";
  abnormalFlags = "";
  observationDate?: string;
  rangeLow = "";
  rangeHigh = "";
}

export class SurveyGroup {
  value = 0;
  text = "";
}

export class ParticipantSynopsisResponse {
  synopsis = "";
}

export class ParticipantSynopsisRequest
{
    participantId = 0;
    clientId = 0;
    timeZone = "";
}

export class SurveyGroupParticipant {
  participantIds: number[] = [];
  groupId = 0;
  clientId = 0;
}

export enum AssessmentTypes {
  GAD7 = 1,
  PHQ9 = 2,
  SOWS = 3,
  Cravings = 4
}

export const SETTINGS = {
  NONE: "none",
  EGAGE_PLAN: "eGagePlan",
  SHOW_HIDE: "showHide"
}

export const DISPLAY = {
  SHOW: "Visible",
  HIDE: "Hidden"
}

export enum WatchStatus {
  NORMAL = 1,
  NO_DATA = 2,
  VERSION = 3,
  NOT_ASSIGNED = 4
}